import { ArrowDropDownOutlined, ClearOutlined } from "@mui/icons-material";
import { Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

export const DropdownSelector = ({
  value,
  onChange,
  popupId,
  sx,
  className,
  options = [],
  getOptionKey = (index) => index,
  getOptionLabel = (option) => option,
  disabled = false,
  variant = "outlined",
  isRequired = true,
  clearLabel = "All",
  ...otherProps
}) => {
  return (
    <PopupState variant="popover" popupId={popupId}>
      {(popupState) => (
        <>
          <Button
            variant={variant}
            disabled={disabled}
            sx={sx}
            className={className}
            {...bindTrigger(popupState)}
            {...otherProps}
          >
            {value || clearLabel} <ArrowDropDownOutlined />
          </Button>
          <Menu {...bindMenu(popupState)}>
            {!isRequired && (
              <>
                <MenuItem
                  onClick={() => {
                    onChange(null);
                    popupState.close();
                  }}
                >
                  <ListItemIcon>
                    <ClearOutlined fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{clearLabel}</ListItemText>
                </MenuItem>
                <Divider />
              </>
            )}
            {options.map((option, index) => (
              <MenuItem
                key={getOptionKey(option, index)}
                onClick={() => {
                  onChange(option);
                  popupState.close();
                }}
              >
                {getOptionLabel(option)}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default DropdownSelector;
